import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        redirect: "/login",
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/user/Login'),
    },
    {
        path: '/user/register',
        name: 'register',
        component: () => import('../views/user/register'),
    },
    {
        path: '/user/index',
        name: 'index',
        component: () => import('../views/user/index'),
        meta: {
            title: '我的',
            keepAlive: true
        }
    },
    {
        path: '/info/index',
        name: 'info_index',
        component: () => import('../views/info/index'),
        meta: {
            title: '信息',
            keepAlive: true
        }
    },
    {
        path: '/contact/index',
        name: 'contact',
        component: () => import('../views/contact/index'),
        meta: {
            title: '通讯录',
            keepAlive: true
        }
    },
    {
        path: '/zhuanqian/index',
        name: 'zhuanqian',
        component: () => import('../views/zhuanqian/index'),
        meta: {
            title: '发现',
            keepAlive: true
        }
    },
    {
        path: '/contact/custom',
        name: 'custom',
        component: () => import('../views/contact/custom'),
        meta: {
            title: '客服列表',
            keepAlive: true
        }
    },
    {
        path: '/contact/custom_detail',
        name: 'custom_detail',
        component: () => import('../views/contact/custom_detail'),
        meta: {
            title: '客服详情',
            keepAlive: true
        }
    },
    {
        path: '/contact/not_join_user',
        name: 'not_join_user',
        component: () => import('../views/contact/not_join_user'),
        meta: {
            title: '待拉群用户'
        }
    },
    {
        path: '/contact/link',
        name: 'link',
        component: () => import('../views/contact/link'),
        meta: {
            title: '常用链接',
            keepAlive: true
        }
    },
    {
        path: '/chat/index',
        name: 'chat',
        component: () => import('../views/chat/index'),
        meta: {
            title: '聊天',
            keepAlive: false
        }
    },
    {
        path: '/chat/info',
        name: 'chatinfo',
        component: () => import('../views/chat/info'),
        meta: {
            title: '聊天信息',
            keepAlive: true
        }
    },
    {
        path: '/chat/send_packet',
        name: 'chat_send_packet',
        component: () => import('../views/chat/send_packet'),
        meta: {
            title: '发红包'
        }
    },
    {
        path: '/chat/packet_log',
        name: 'chat_packet_log',
        component: () => import('../views/chat/packet_log'),
        meta: {
            title: '红包详情'
        }
    },
    {
        path: '/chat/top',
        name: 'chat_top',
        component: () => import('../views/chat/top'),
        meta: {
            title: '置顶消息',
            keepAlive: true
        }
    },
    {
        path: '/contact/new_friends',
        name: 'new_friends',
        component: () => import('../views/contact/new_friends'),
        meta: {
            title: '新朋友',
            keepAlive: true
        }
    },
    {
        path: '/message/index',
        name: 'message',
        component: () => import('../views/message/index'),
        meta: {
            title: '消息助手',
            keepAlive: true
        }
    },
    {
        path: '/friend/find',
        name: 'find',
        component: () => import('../views/friend/find'),
        meta: {
            title: '搜索',
            keepAlive: true
        }
    },
    {
        path: '/friend/info',
        name: 'friend_info',
        component: () => import('../views/friend/info'),
        meta: {
            title: '用户信息',
            keepAlive: true
        }
    },
    {
        path: '/friend/set_name',
        name: 'set_name',
        component: () => import('../views/friend/set_name'),
        meta: {
            title: '设置备注',
            keepAlive: true
        }
    },
    {
        path: '/friend/apply',
        name: 'apply',
        component: () => import('../views/friend/apply'),
        meta: {
            title: '添加好友'
        }
    },
    {
        path: '/group/group_list',
        name: 'group_list',
        component: () => import('../views/group/group_list'),
        meta: {
            title: '群组列表',
            keepAlive: true
        }
    },
    {
        path: '/group/edit',
        name: 'edit',
        component: () => import('../views/group/edit'),
        meta: {
            title: '创建群组'
        }
    },
    {
        path: '/group/group_sending',
        name: 'group_sending',
        component: () => import('../views/group/group_sending'),
        meta: {
            title: '选择群组或好友'
        }
    },
    {
        path: '/group/index',
        name: 'group_index',
        component: () => import('../views/group/index'),
        meta: {
            title: '群组聊天',
            keepAlive: false
        }
    },
    {
        path: '/group/info',
        name: 'group_info',
        component: () => import('../views/group/info'),
        meta: {
            title: '聊天信息',
            keepAlive: true
        }
    },
    {
        path: '/group/remarks',
        name: 'remarks',
        component: () => import('../views/group/remarks'),
        meta: {
            title: '聊天信息'
        }
    },
    {
        path: '/group/nickname',
        name: 'group_nickname',
        component: () => import('../views/group/nickname'),
        meta: {
            title: '我在群里的昵称',
            keepAlive: true
        }
    },
    {
        path: '/group/add',
        name: 'add',
        component: () => import('../views/group/add'),
        meta: {
            title: '选择联系人'
        }
    },
    {
        path: '/group/add_admin',
        name: 'add_admin',
        component: () => import('../views/group/add_admin'),
        meta: {
            title: '聊天成员'
        }
    },
    {
        path: '/group/group_admin',
        name: 'group_admin',
        component: () => import('../views/group/group_admin'),
        meta: {
            title: '管理员列表'
        }
    },
    {
        path: '/group/jinyans',
        name: 'jinyans',
        component: () => import('../views/group/jinyans'),
        meta: {
            title: '成员禁言'
        }
    },
    {
        path: '/group/member',
        name: 'member',
        component: () => import('../views/group/member'),
        meta: {
            title: '全部成员'
        }
    },
    {
        path: '/group/name',
        name: 'name',
        component: () => import('../views/group/name'),
        meta: {
            title: '修改群聊名称',
            keepAlive: true
        }
    },
    {
        path: '/group/notice',
        name: 'notice',
        component: () => import('../views/group/notice'),
        meta: {
            title: '修改公告',
            keepAlive: true
        }
    },
    {
        path: '/group/push_group',
        name: 'push_group',
        component: () => import('../views/group/push_group'),
        meta: {
            title: '选择群组或好友'
        }
    },
    {
        path: '/group/qrcode',
        name: 'qrcode',
        component: () => import('../views/group/qrcode'),
        meta: {
            title: '群二维码'
        }
    },
    {
        path: '/group/share',
        name: 'group_share',
        component: () => import('../views/group/share'),
        meta: {
            title: '加入群聊'
        }
    },
    {
        path: '/group/reduce',
        name: 'reduce',
        component: () => import('../views/group/reduce'),
        meta: {
            title: '聊天成员',
            keepAlive: true
        }
    },
    {
        path: '/group/reduce_admin',
        name: 'reduce_admin',
        component: () => import('../views/group/reduce_admin'),
        meta: {
            title: '管理员列表',
            keepAlive: true
        }
    },
    {
        path: '/group/send_packet',
        name: 'send_packet',
        component: () => import('../views/group/send_packet'),
        meta: {
            title: '发红包'
        }
    },
    {
        path: '/group/send_packet2',
        name: 'send_packet2',
        component: () => import('../views/group/send_packet2'),
        meta: {
            title: '发红包'
        }
    },
    {
        path: '/group/send_packet3',
        name: 'send_packet3',
        component: () => import('../views/group/send_packet3'),
        meta: {
            title: '发红包'
        }
    },
    {
        path: '/group/send_packet4',
        name: 'send_packet4',
        component: () => import('../views/group/send_packet4'),
        meta: {
            title: '发红包'
        }
    },
    {
        path: '/group/image_list',
        name: 'image_list',
        component: () => import('../views/group/image_list'),
        meta: {
            title: '图片',
            keepAlive: true
        }
    },
    {
        path: '/group/video_list',
        name: 'video_list',
        component: () => import('../views/group/video_list'),
        meta: {
            title: '视频',
            keepAlive: true
        }
    },
    {
        path: '/group/url_list',
        name: 'url_list',
        component: () => import('../views/group/url_list'),
        meta: {
            title: '链接',
            keepAlive: true
        }
    },
    {
        path: '/group/top',
        name: 'group_top',
        component: () => import('../views/group/top'),
        meta: {
            title: '置顶消息',
            keepAlive: true
        }
    }, {
        path: '/group/article',
        name: 'group_article',
        component: () => import('../views/group/article'),
        meta: {
            title: '推送文章',
            keepAlive: true
        }
    },
    {
        path: '/friend/accept',
        name: 'accept',
        component: () => import('../views/friend/accept'),
        meta: {
            title: '通过好友验证'
        }
    },
    {
        path: '/user/wallet',
        name: 'wallet',
        component: () => import('../views/user/wallet'),
        meta: {
            title: '钱包',
            keepAlive: true
        }
    },
    {
        path: '/user/editPayPassword',
        name: 'editPayPassword',
        component: () => import('../views/user/editPayPassword'),
        meta: {
            title: '修改支付密码'
        }
    },
    {
        path: '/user/editPwd',
        name: 'editPwd',
        component: () => import('../views/user/editPwd'),
        meta: {
            title: '修改密码'
        }
    },
    {
        path: '/user/touzhu',
        name: 'touzhu',
        component: () => import('../views/user/touzhu'),
        meta: {
            title: '游戏记录',
            keepAlive: true
        }
    },
    {
        path: '/user/solitaire',
        name: 'solitaire',
        component: () => import('../views/user/solitaire'),
        meta: {
            title: '游戏记录',
            keepAlive: true
        }
    },
    {
        path: '/user/niuniu',
        name: 'niuniu',
        component: () => import('../views/user/niuniu'),
        meta: {
            title: '游戏记录',
            keepAlive: true
        }
    },
    {
        path: '/user/mine',
        name: 'mine',
        component: () => import('../views/user/mine'),
        meta: {
            title: '游戏记录',
            keepAlive: true
        }
    },
    {
        path: '/user/leyou',
        name: 'user_leyou',
        component: () => import('../views/user/leyou'),
        meta: {
            title: '游戏记录',
            keepAlive: true
        }
    },
    {
        path: '/user/backwater',
        name: 'backwater',
        component: () => import('../views/user/backwater'),
        meta: {
            title: '反水记录',
            keepAlive: true
        }
    },
    {
        path: '/user/recharge',
        name: 'recharge',
        component: () => import('../views/user/recharge'),
        meta: {
            title: '充值记录',
            keepAlive: true
        }
    },
    {
        path: '/user/withdrawal',
        name: 'withdrawal',
        component: () => import('../views/user/withdrawal'),
        meta: {
            title: '提现记录',
            keepAlive: true
        }
    },
    {
        path: '/user/subordinate',
        name: 'subordinate',
        component: () => import('../views/user/subordinate'),
        meta: {
            title: '下线列表',
            keepAlive: true
        }
    },
    {
        path: '/user/customer_touzhu',
        name: 'customer_touzhu',
        component: () => import('../views/user/customer_touzhu'),
        meta: {
            title: '下单记录',
            keepAlive: true
        }
    },
    {
        path: '/user/customer_orders',
        name: 'customer_orders',
        component: () => import('../views/user/customer_orders'),
        meta: {
            title: '下线明细',
            keepAlive: true
        }
    },
    {
        path: '/user/addUser',
        name: 'addUser',
        component: () => import('../views/user/addUser'),
        meta: {
            title: '开户'
        }
    },
    {
        path: '/user/sign',
        name: 'user_sign',
        component: () => import('../views/user/sign'),
        meta: {
            title: '每日签到',
            keepAlive: true
        }
    },
    {
        path: '/question/index',
        name: 'question_index',
        component: () => import('../views/question/index'),
        meta: {
            title: '常见问题',
            keepAlive: true
        }
    },
    {
        path: '/question/detail',
        name: 'inddetailex',
        component: () => import('../views/question/detail'),
        meta: {
            title: '问题详情',
            keepAlive: true
        }
    },
    {
        path: '/user/info',
        name: 'user_info',
        component: () => import('../views/user/info'),
        meta: {
            title: '个人信息',
            keepAlive: true
        }
    },
    {
        path: '/user/addBank',
        name: 'addBank',
        component: () => import('../views/user/addBank'),
        meta: {
            title: '添加账号'
        }
    },
    {
        path: '/user/redpackhistory',
        name: 'redpackhistory',
        component: () => import('../views/user/redpackhistory'),
        meta: {
            title: '红包记录'
        }
    },
    {
        path: '/user/packet_log',
        name: 'user_packet_log',
        component: () => import('../views/user/packet_log'),
        meta: {
            title: '红包详情'
        }
    },
    {
        path: '/pay/pay',
        name: 'pay',
        component: () => import('../views/pay/pay'),
    },
    {
        path: '/pay/cashout',
        name: 'pay_cashout',
        component: () => import('../views/pay/cashout'),
    },
    {
        path: '/pay/cashout_agent',
        name: 'cashout_agent',
        component: () => import('../views/pay/cashout_agent'),
    },
    {
        path: '/pay/cashout_default',
        name: 'cashout_default',
        component: () => import('../views/pay/cashout_default'),
    },
    {
        path: '/pay/cashout_c2clog',
        name: 'cashout_c2clog',
        component: () => import('../views/pay/cashout_c2clog'),
    },
    {
        path: '/pay/cashout_c2c_list',
        name: 'cashout_c2c_list',
        component: () => import('../views/pay/cashout_c2c_list'),
    },
    {
        path: '/pay/pay_c2c_add',
        name: 'pay_c2c_add',
        component: () => import('../views/pay/pay_c2c_add'),
    },
    {
        path: '/pay/pay_c2c_order',
        name: 'pay_c2c_order',
        component: () => import('../views/pay/pay_c2c_order'),
    },
    {
        path: '/pay/pay_c2c_money',
        name: 'pay_c2c_money',
        component: () => import('../views/pay/pay_c2c_money'),
    },
    {
        path: '/pay/pay_agent',
        name: 'pay_agent',
        component: () => import('../views/pay/pay_agent'),
    },
    {
        path: '/pay/pay_c2c',
        name: 'pay_c2c',
        component: () => import('../views/pay/pay_c2c'),
    },
    {
        path: '/pay/pay_c2clog',
        name: 'pay_c2clog',
        component: () => import('../views/pay/pay_c2clog'),
    },
    {
        path: '/pay/pay_gateway',
        name: 'pay_gateway',
        component: () => import('../views/pay/pay_gateway'),
    },
    {
        path: '/pay/pay_qrcode',
        name: 'pay_qrcode',
        component: () => import('../views/pay/pay_qrcode'),
    },
    {
        path: '/pay/pay_third',
        name: 'pay_third',
        component: () => import('../views/pay/pay_third'),
    },
    {
        path: '/pay/pay_wanbi',
        name: 'pay_wanbi',
        component: () => import('../views/pay/pay_wanbi'),
    },
    {
        path: '/pay/pay_kdpay',
        name: 'pay_kdpay',
        component: () => import('../views/pay/pay_kdpay'),
    },
    {
        path: '/pay/pay_jdpay',
        name: 'pay_jdpay',
        component: () => import('../views/pay/pay_jdpay'),
    },
    {
        path: '/pay/pay_yizhifu',
        name: 'pay_yizhifu',
        component: () => import('../views/pay/pay_yizhifu'),
    },
    {
        path: '/pay/pay_xpay',
        name: 'pay_xpay',
        component: () => import('../views/pay/pay_xpay'),
    },
    {
        path: '/pay/pay_qpay',
        name: 'pay_qpay',
        component: () => import('../views/pay/pay_qpay'),
    },
    {
        path: '/pay/proceeds',
        name: 'proceeds',
        component: () => import('../views/pay/proceeds'),
    },
    {
        path: '/user/editBank',
        name: 'editBank',
        component: () => import('../views/user/editBank'),
    },
    {
        path: '/user/nickname',
        name: 'user_nickname',
        component: () => import('../views/user/nickname'),
    },
    {
        path: '/user/share',
        name: 'share',
        component: () => import('../views/user/share'),
        meta: {
            title: '分享',
        },
    },
    {
        path: '/user/redpacklog',
        name: 'redpacklog',
        component: () => import('../views/user/redpacklog'),
        meta: {
            title: '分享',
        },
    },
    {
        path: '/user/customer_order_detail',
        name: 'customer_order_detail',
        component: () => import('../views/user/customer_order_detail'),
        meta: {
            title: '个人信息',
            keepAlive: true
        },
    },
    {
        path: '/user/verify_user',
        name: 'verify_user',
        component: () => import('../views/user/verify_user'),
        meta: {
            title: '账号验证',
        },
    },
    {
        path: '/user/cashout',
        name: 'user_cashout',
        component: () => import('../views/user/cashout'),
        meta: {
            title: '提现',
        },
    },
    {
        path: '/zhuanqian/predict',
        name: 'predict',
        component: () => import('../views/zhuanqian/predict'),
        meta: {
            title: '开奖预测',
            keepAlive: true
        }
    },
    {
        path: '/zhuanqian/predict_detail',
        name: 'predict_detail',
        component: () => import('../views/zhuanqian/predict_detail'),
        meta: {
            title: '预测详情',
            keepAlive: true
        }
    },
    {
        path: '/zhuanqian/kaijiang',
        name: 'kaijiang',
        component: () => import('../views/zhuanqian/kaijiang'),
        meta: {
            title: '历史开奖',
            keepAlive: true
        }
    },
    {
        path: '/zhuanqian/trend',
        name: 'trend',
        component: () => import('../views/zhuanqian/trend'),
        meta: {
            title: '走势图表',
            keepAlive: true
        }
    },
    {
        path: '/zhuanqian/game',
        name: 'game',
        component: () => import('../views/zhuanqian/game'),
        meta: {
            title: '杀号定胆',
            keepAlive: true
        }
    },
    {
        path: '/zhuanqian/game_position',
        name: 'game_position',
        component: () => import('../views/zhuanqian/game_position'),
        meta: {
            title: '定位杀号',
            keepAlive: true
        }
    },
    {
        path: '/zhuanqian/dream',
        name: 'dream',
        component: () => import('../views/zhuanqian/dream'),
        meta: {
            title: '解梦',
            keepAlive: true
        }
    },
    {
        path: '/zhuanqian/page',
        name: 'zhuanqian_page',
        component: () => import('../views/zhuanqian/page'),
        meta: {
            title: '发现',
            keepAlive: true
        }
    },
    {
        path: '/picture/index',
        name: 'picture_index',
        component: () => import('../views/picture/index'),
        meta: {
            title: '图库',
            keepAlive: true
        }
    },
    {
        path: '/picture/detail',
        name: 'picture_detail',
        component: () => import('../views/picture/detail'),
        meta: {
            title: '图库详情',
            keepAlive: true
        }
    },
    {
        path: '/picture/search',
        name: 'picture_search',
        component: () => import('../views/picture/search'),
        meta: {
            title: '图库搜索',
            keepAlive: true
        }
    },
    {
        path: '/picture/live',
        name: 'picture_live',
        component: () => import('../views/picture/live'),
        meta: {
            title: '开奖直播',
            keepAlive: true
        }
    },
    {
        path: '/picture/live_back',
        name: 'picture_live_back',
        component: () => import('../views/picture/live_back'),
        meta: {
            title: '直播回放',
            keepAlive: true
        }
    },
    {
        path: '/picture/live_detail',
        name: 'picture_live_detail',
        component: () => import('../views/picture/live_detail'),
        meta: {
            title: '直播详情',
            keepAlive: true
        }
    },
    {
        path: '/picture/lottery',
        name: 'picture_lottery',
        component: () => import('../views/picture/lottery'),
        meta: {
            title: '开奖历史',
            keepAlive: true
        }
    },
    {
        path: '/picture/date',
        name: 'picture_date',
        component: () => import('../views/picture/date'),
        meta: {
            title: '开奖日期',
            keepAlive: true
        }
    },
    {
        path: '/chat/note',
        name: 'chat_note',
        component: () => import('../views/chat/note'),
        meta: {
            title: '日记详情',
            keepAlive: true
        }
    },
    {
        path: '/group/note',
        name: 'group_note',
        component: () => import('../views/group/note'),
        meta: {
            title: '日记详情',
            keepAlive: true
        }
    },
    {
        path: '/group/log',
        name: 'group_log',
        component: () => import('../views/group/log'),
        meta: {
            title: '游戏记录',
            keepAlive: true
        }
    },
    {
        path: '/group/live',
        name: 'group_live',
        component: () => import('../views/group/live'),
        meta: {
            title: '群直播'
        }
    },
    {
        path: '/user/account',
        name: 'user_account',
        component: () => import('../views/user/account'),
        meta: {
            title: '钱包明细',
            keepAlive: true
        }
    },
    {
        path: '/customer',
        name: 'customer',
        component: () => import('../views/customer/index'),
        meta: {
            title: '选择客服'
        }
    },
    {
        path: '/customer/go',
        name: 'customer_go',
        component: () => import('../views/customer/go'),
        meta: {
            title: '在线客服'
        }
    },
    {
        path: '/customer/download',
        name: 'customer_download',
        component: () => import('../views/customer/download'),
        meta: {
            title: '下载APP'
        }
    },
    {
        path: '/customer/group',
        name: 'customer_group',
        component: () => import('../views/customer/group'),
        meta: {
            title: '群组分享'
        }
    },
    {
        path: '/customer/chat',
        name: 'customer_chat',
        component: () => import('../views/customer/chat'),
        meta: {
            title: '在线客服',
            keepAlive: true
        }
    },
    {
        path: '/guidance',
        name: 'guidance',
        component: () => import('../views/guidance/index'),
        meta: {
            title: '落地页',
            keepAlive: true
        }
    },
    {
        path: '/leyou',
        name: 'leyou',
        component: () => import('../views/zhuanqian/leyou'),
        meta: {
            title: '乐游棋牌',
            keepAlive: true
        }
    },
    {
        path: '/pggame',
        name: 'pggame',
        component: () => import('../views/zhuanqian/pggame'),
        meta: {
            title: 'PG游戏',
            keepAlive: true
        }
    },
    {
        path: '/animal',
        name: 'animal',
        component: () => import('../views/zhuanqian/animal/index'),
        meta: {
            title: '动物运动会',
            keepAlive: true
        }
    },
    {
        path: '/user/animal',
        name: 'userAnimal',
        component: () => import('../views/user/animal'),
        meta: {
            title: '竞猜记录',
            keepAlive: true
        }
    },
    {
        path: '/animal/history',
        name: 'animalHistory',
        component: () => import('../views/zhuanqian/animal/history'),
        meta: {
            title: '开奖历史',
            keepAlive: true
        }
    },
    {
        path: '/sideline',
        name: 'sideline',
        component: () => import('../views/sideline/index'),
        meta: {
            title: '网上赚钱',
            keepAlive: true
        }
    },
    {
        path: '/sideline/detail',
        name: 'sideline_detail',
        component: () => import('../views/sideline/detail'),
        meta: {
            title: '任务详情',
            keepAlive: true
        }
    },
    {
        path: '/sideline/post',
        name: 'sideline_post',
        component: () => import('../views/sideline/post'),
        meta: {
            title: '发布任务'
        }
    },
    {
        path: '/user/sideline/my',
        name: 'sideline_my',
        component: () => import('../views/user/sideline/my'),
        meta: {
            title: '我发布的任务',
            keepAlive: true
        }
    },
    {
        path: '/user/sideline/review',
        name: 'sideline_review',
        component: () => import('../views/user/sideline/review'),
        meta: {
            title: '审核任务',
            keepAlive: true
        }
    },
    {
        path: '/user/sideline/apply',
        name: 'sideline_apply',
        component: () => import('../views/user/sideline/apply'),
        meta: {
            title: '我报名的任务',
            keepAlive: true
        }
    },
    {
        path: '/user/sideline/collect',
        name: 'sideline_collect',
        component: () => import('../views/user/sideline/collect'),
        meta: {
            title: '我收藏的任务',
            keepAlive: true
        }
    },
    {
        path: '/sideline/submit',
        name: 'sideline_submit',
        component: () => import('../views/sideline/submit'),
        meta: {
            title: '提交任务'
        }
    },
    {
        path: '/chat/hs',
        name: 'hslogin',
        component: () => import('../views/user/hslogin'),
        meta: {
            title: '登录中'
        }
    },
    {
        path: '/demand',
        name: 'demand',
        component: () => import('../views/demand/index'),
        meta: {
            title: '供需版块',
            keepAlive: true
        }
    },
    {
        path: '/demand/detail',
        name: 'demand_detail',
        component: () => import('../views/demand/detail'),
        meta: {
            title: '供需详情',
            keepAlive: true
        }
    },
    {
        path: '/demand/post',
        name: 'demand_post',
        component: () => import('../views/demand/post'),
        meta: {
            title: '发布需求'
        }
    },
    {
        path: '/user/demand',
        name: 'user_demand',
        component: () => import('../views/user/demand'),
        meta: {
            title: '我的需求',
            keepAlive: true
        }
    },
    {
        path: '/user/database',
        name: 'database_index',
        component: () => import('../views/user/database/index'),
        meta: {
            title: '我的稿件',
            keepAlive: true
        }
    },
    {
        path: '/user/database/post',
        name: 'database_post',
        component: () => import('../views/user/database/post'),
        meta: {
            title: '投稿'
        }
    },
    {
        path: '/chat/video',
        name: 'chat_video',
        component: () => import('../views/chat/video'),
        meta: {
            title: '视频通话'
        }
    },
    {
        path: '/chat/audio',
        name: 'chat_audio',
        component: () => import('../views/chat/audio'),
        meta: {
            title: '语音通话'
        }
    },
    {
        path: '/forum',
        name: 'forum',
        component: () => import('../views/forum/index'),
        meta: {
            title: '讲堂视频',
            keepAlive: true
        }
    },
    {
        path: '/forum/detail',
        name: 'forum_detail',
        component: () => import('../views/forum/detail'),
        meta: {
            title: '视频详情',
            keepAlive: true
        }
    },
    {
        path: '/lottery',
        name: 'lottery',
        component: () => import('../views/lottery/index'),
        meta: {
            title: '排列五',
            keepAlive: true
        }
    },
    {
        path: '/lottery/ranking',
        name: 'lottery_ranking',
        component: () => import('../views/lottery/ranking'),
        meta: {
            title: '名人榜',
            keepAlive: true
        }
    },
    {
        path: '/lottery/circle',
        name: 'lottery_circle',
        component: () => import('../views/lottery/circle'),
        meta: {
            title: '彩友圈',
            keepAlive: true
        }
    },
    {
        path: '/lottery/detail',
        name: 'lottery_detail',
        component: () => import('../views/lottery/detail'),
        meta: {
            title: '帖子详情',
            keepAlive: true
        }
    },
    {
        path: '/lottery/post',
        name: 'lottery_post',
        component: () => import('../views/lottery/post'),
        meta: {
            title: '发布帖子'
        }
    },
    {
        path: '/lottery/reward',
        name: 'lottery_reward',
        component: () => import('../views/lottery/reward'),
        meta: {
            title: '打赏'
        }
    },
    {
        path: '/lottery/zone',
        name: 'lottery_zone',
        component: () => import('../views/lottery/zone'),
        meta: {
            title: '个人信息',
            keepAlive: true
        }
    },
    {
        path: '/lottery/record',
        name: 'lottery_record',
        component: () => import('../views/lottery/record'),
        meta: {
            title: '个人战绩',
            keepAlive: true
        }
    },
    {
        path: '/lottery/plan',
        name: 'lottery_plan',
        component: () => import('../views/lottery/plan'),
        meta: {
            title: '发布方案'
        }
    },
    {
        path: '/lottery/rule',
        name: 'lottery_rule',
        component: () => import('../views/lottery/rule'),
        meta: {
            title: '规律图',
            keepAlive: true
        }
    },
    {
        path: '/lottery/hen',
        name: 'lottery_hen',
        component: () => import('../views/lottery/hen'),
        meta: {
            title: '老母鸡汤'
        }
    },
    {
        path: '/lottery/help',
        name: 'lottery_help',
        component: () => import('../views/lottery/help/index'),
        meta: {
            title: '彩友圈说明',
            keepAlive: true
        }
    },
    {
        path: '/lottery/help',
        name: 'lottery_help',
        component: () => import('../views/lottery/help/index'),
        meta: {
            title: '说明',
            keepAlive: true
        }
    },
    {
        path: '/lottery/help/detail',
        name: 'lottery_help_detail',
        component: () => import('../views/lottery/help/detail'),
        meta: {
            title: '说明',
            keepAlive: true
        }
    },
    {
        path: '/lottery/search',
        name: 'lottery_search',
        component: () => import('../views/lottery/search/index'),
        meta: {
            title: '奖表搜索',
            keepAlive: true
        }
    },
    {
        path: '/lottery/search/caiyou',
        name: 'lottery_search_caiyou',
        component: () => import('../views/lottery/search/caiyou'),
        meta: {
            title: '彩友搜索',
            keepAlive: true
        }
    },
    {
        path: '/lottery/follow',
        name: 'lottery_follow',
        component: () => import('../views/lottery/follow'),
        meta: {
            title: 'TA关注的人',
            keepAlive: true
        }
    },
    {
        path: '/lottery/fans',
        name: 'lottery_fans',
        component: () => import('../views/lottery/fans'),
        meta: {
            title: 'TA的粉丝',
            keepAlive: true
        }
    },
    {
        path: '/lottery/master_vip',
        name: 'lottery_master_vip',
        component: () => import('../views/lottery/vip/master'),
        meta: {
            title: '大师包月',
            keepAlive: true
        }
    },
    {
        path: '/lottery/user_vip',
        name: 'lottery_user_vip',
        component: () => import('../views/lottery/vip/vip'),
        meta: {
            title: '会员包月',
            keepAlive: true
        }
    },
    {
        path: '/lottery/list',
        name: 'lottery_list',
        component: () => import('../views/lottery/list'),
        meta: {
            title: '大师榜单',
            keepAlive: true
        }
    },
    {
        path: '/lottery/drawing',
        name: 'lottery_drawing',
        component: () => import('../views/lottery/drawing'),
        meta: {
            title: '画规',
            keepAlive: true
        }
    },
    {
        path: '/lottery/all',
        name: 'lottery_all',
        component: () => import('../views/lottery/all'),
        meta: {
            title: '全部',
            keepAlive: true
        }
    },
    {
        path: '/lottery/history',
        name: 'lottery_history',
        component: () => import('../views/lottery/history'),
        meta: {
            title: '开奖记录',
            keepAlive: true
        }
    }
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})


export default router
